export default __webpack_public_path__ + "static/media/flip_card_2.e58de6b0.png";